import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReadLess, ReadMore } from 'autogen/translation-keys/trans-website-shared-buttons';
import InlineButton from 'components/generic/InlineButton';

interface IToggleReadMoreButton {
    collapsed: boolean;
    onClickCallback: (collapsed) => void;
}

export default function ToggleReadMoreButton({
    collapsed,
    onClickCallback,
    ...restProps
}: IToggleReadMoreButton): JSX.Element {
    const { t } = useTranslation();

    return (
        <InlineButton
            variant="dark"
            fontWeight="semibold"
            size="sm"
            onClick={() => onClickCallback(!collapsed)}
            {...restProps}
        >
            {collapsed ? t(ReadMore) : t(ReadLess)}
        </InlineButton>
    );
}
